<template>
  <section class="signin">
    <h1 class="title">Sign In</h1>
    <signinForm />
  </section>
</template>
<script>
import signinForm from '@/components/Forms/Auth/Signin.vue';

export default {
  components: {
    signinForm,
  },
};
</script>
<style lang=scss>
  .signin {
    .title {
      margin-top: 1em;
      text-align: center;
      font-size: 1.5em !important;
      font-weight: bold;
    }
  }
</style>
